module.exports = __webpack_public_path__ + "img/vacance1.18d1e6e8.jpg";